import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import _ from 'lodash';
import Table from 'react-bootstrap/Table';
import config from '../../config';

// TODO
// Error handle
// loading spinner
// possibly remove tools

class RegistrationProviderChartV2 extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
            type:props.type,
            height:props.height,
            maxHeight:props.maxHeight,
            loading:true,
            theHead:[]
            
      };
    }

    roundPercent(value){
        let thisGuy=value*100;
        thisGuy=Math.round(thisGuy * 10) / 10;
        return thisGuy;
    }

    async loadOut(){
        // const qValues = qs.parse(this.props.location.search);
        let formData;
        let qResp;
        let qData;
        let qWhere="1=1";
        let url=config.apiv2.registrationProvider;
        let theHead=[];
        let theBody=[];

        formData=new FormData();
        formData.append("where",qWhere);
        formData.append("outFields","*");
        formData.append("returnGeometry","false");
        formData.append("orderByFields","Total DESC");
        formData.append("returnDistinctValues","false");
        formData.append("f","json");

        try{
            qResp = await fetch(url+"/query",{method:"post",body:formData});
            qData = await qResp.json();
        }catch(err){
            console.log(err);
        }

        if(_.get(qData,"features.length",0)>0){
            theHead.push(<><th key={Math.floor(Math.random()*10100)}>Site</th><th key={Math.floor(Math.random()*10100)}>Asian</th><th key={Math.floor(Math.random()*10100)}>Black</th><th key={Math.floor(Math.random()*10100)}>Hispanic</th><th key={Math.floor(Math.random()*10100)}>White</th><th key={Math.floor(Math.random()*10100)}>Other</th><th key={Math.floor(Math.random()*10100)}>Total</th></>);

            for (const [key,value] of Object.entries(qData.features)){
                let tempTotal=value.attributes.Asian+value.attributes.Black+value.attributes.Hispanic+value.attributes.Other_Race+value.attributes.White;

                theBody.push(<tr key={Math.floor(Math.random()*10100)}><td key={Math.floor(Math.random()*10100)}>{value.attributes.Site}</td><td key={Math.floor(Math.random()*10100)}>{value.attributes.Asian}</td><td key={Math.floor(Math.random()*10100)}>{value.attributes.Black}</td><td key={Math.floor(Math.random()*10100)}>{value.attributes.Hispanic}</td><td key={Math.floor(Math.random()*10100)}>{value.attributes.White}</td><td key={Math.floor(Math.random()*10100)}>{value.attributes.Other_Race}</td><td key={Math.floor(Math.random()*10100)}>{tempTotal}</td></tr>);

                theBody.push(<tr key={Math.floor(Math.random()*10100)}><td key={Math.floor(Math.random()*10100)}></td><td key={Math.floor(Math.random()*10100)}><i>{Math.round(((value.attributes.Asian/tempTotal)*100) * 10) / 10}%</i></td><td key={Math.floor(Math.random()*10100)}><i>{Math.round(((value.attributes.Black/tempTotal)*100) * 10) / 10}%</i></td><td key={Math.floor(Math.random()*10100)}><i>{Math.round(((value.attributes.Hispanic/tempTotal)*100) * 10) / 10}%</i></td><td key={Math.floor(Math.random()*10100)}><i>{Math.round(((value.attributes.White/tempTotal)*100) * 10) / 10}%</i></td><td key={Math.floor(Math.random()*10100)}><i>{Math.round(((value.attributes.Other_Race/tempTotal)*100) * 10) / 10}%</i></td><td key={Math.floor(Math.random()*10100)}></td></tr>);
            }
            
            this.setState({
                loading:false,
                error:false,
                theHead:theHead,
                theBody:theBody
            });
        }else{
            // error handle
            this.setState({
                loading:false,
                error:true
            });
        }
    }

    componentDidMount(){
        this.loadOut();
    }

    render() {
        if(this.state.loading===true){
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <div id="loader" style={{textAlign:"center"}}>
                        <Row>
                            <Col>
                                <Spinner animation="border" variant="primary" />
                            </Col>
                        </Row>
                    </div>
                </Container>
            );

        }else if(this.state.loading===false && this.state.error===true){
            //show error
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <Alert></Alert>
                </Container>
            );
        }else{
            return (
                <>
                    <Table striped bordered hover size="sm" responsive style={{fontSize:"10pt",height:this.state.height}}>
                        <thead>
                            <tr>
                            {/* style={{backgroundColor:"#b63a3a",color:"#FFFFFF"}} */}
                                {this.state.theHead}
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.theBody}
                        </tbody>
                    </Table>
                </>
            );
        }
    }
}

export default RegistrationProviderChartV2;